export const logRequestDetails = async (request?: Request, requestBody?: any) => {
    try {
        if (request) {
            console.log('request url: ', request.url)
        }
        if (requestBody) {
            console.log('request body: ', requestBody)
        }
    } catch {
        console.log('could not log request details')
    }
}
